module.exports = __webpack_public_path__ + "static/media/12-2.d3b7f066.svg";